import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { FC, ReactElement } from 'react'
import styled from 'styled-components'
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import AnchorLink from 'react-anchor-link-smooth-scroll'
import Papa from 'papaparse'
import Indicator from 'components/Indicator'
import { Link } from '@ta-interaktiv/contentbricks'

let ZuerichData: string[]
let BernData: string[]
let BaselData: string[]

fetch(
  process.env.REACT_APP_DEPLOY_PATH
    ? `${process.env.REACT_APP_DEPLOY_PATH}/data-zuerich.csv`
    : `${process.env.PUBLIC_URL}/data-zuerich.csv`
)
  .then((res) => res.text())
  .then((stringData) => {
    Papa.parse(stringData, {
      complete: function (results) {
        ZuerichData = results.data as string[]
      },
      header: true,
    })
  })

fetch(
  process.env.REACT_APP_DEPLOY_PATH
    ? `${process.env.REACT_APP_DEPLOY_PATH}/data-bern.csv`
    : `${process.env.PUBLIC_URL}/data-bern.csv`
)
  .then((res) => res.text())
  .then((stringData) => {
    Papa.parse(stringData, {
      complete: function (results) {
        BernData = results.data as string[]
      },
      header: true,
    })
  })

fetch(
  process.env.REACT_APP_DEPLOY_PATH
    ? `${process.env.REACT_APP_DEPLOY_PATH}/data-basel.csv`
    : `${process.env.PUBLIC_URL}/data-basel.csv`
)
  .then((res) => res.text())
  .then((stringData) => {
    Papa.parse(stringData, {
      complete: function (results) {
        BaselData = results.data as string[]
      },
      header: true,
    })
  })

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]

  const Zuerich = 'Zürich'
  const Bern = 'Bern'
  const Basel = 'Basel'

  const weatherStationZuerich = 'Zürich-Fluntern'
  const weatherStationBern = 'Bern-Zollikofen'
  const weatherStationBasel = 'Basel-Binningen'

  let clientData = ZuerichData
  // console.log('clientData:', clientData)
  let clientTown = Zuerich
  let clientWeatherStation = weatherStationZuerich

  if (tenant) {
    // console.log('tenant:', tenant)
    switch (tenant.key) {
      case 'bazonline':
        clientData = BaselData
        clientTown = Basel
        clientWeatherStation = weatherStationBasel
        break

      case 'derbund':
      case 'bernerzeitung':
      case 'berneroberlaender':
      case 'thunertagblatt':
      case 'langenthalertagblatt':
        clientData = BernData
        clientTown = Bern
        clientWeatherStation = weatherStationBern
        break
      default:
        clientData = ZuerichData
        clientTown = Zuerich
        clientWeatherStation = weatherStationZuerich
    }
  }

  return (
    <AppContainer className={globalClasses.join(' ')}>
      <div className='ui vertical segment' style={{ paddingTop: '0' }}>
        <div className='ui ta text container first'>
          <p>
            Der aktuelle Sommer ist nur ein Vorgeschmack darauf, was uns in
            Zukunft noch viel häufiger und intensiver erwartet. Schon in wenigen
            Jahrzehnten wird es in der Stadt {clientTown} deutlich heisser sein
            als heute. Unsere Übersicht zeigt anhand von sieben Indikatoren, mit
            welchem Klima wir{' '}
            <span
              className='boxStyle2060 intro'
              style={{ whiteSpace: 'nowrap', fontSize: '.97em' }}
            >
              2060
            </span>{' '}
            und{' '}
            <span
              className='boxStyle2085 intro'
              style={{ whiteSpace: 'nowrap', fontSize: '.97em' }}
            >
              2085
            </span>{' '}
            rechnen müssen – wenn die Menschheit entweder so weiterfährt wie bis
            anhin oder aber den Klimaschutz verstärkt. Die Berechnungen (siehe
            Methodik am Schluss) stützen sich auf die Klimaszenarien des Bundes
            und werden von Andreas Fischer von Meteo Schweiz für uns
            eingeordnet:
          </p>
        </div>

        <div className='ui container'>
          {clientData.map(function (id: any, index: number) {
            console.log(id)
            return (
              <>
                <Indicator key={id.mainTitle} {...id} index={index} />
              </>
            )
          })}
        </div>
      </div>
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)<{ tenant?: string }>`
  width: 100%;
  margin: 0;
  padding: 0;
  font-family: var(--font-sans-serif);

  color: var(--brandblue-main);
  -moz-osx-font-smoothing: grayscale;

  @media only screen and (max-width: 599px) {
    .ui.container {
      margin-left: 2em !important;
      margin-right: 2em !important;
    }
  }

  .text.container.first {
    margin-bottom: 8em;
  }

  p {
    font-family: var(--font-serif);
    font-weight: 100;
    font-size: 18px;
    line-height: 1.6em;
  }

  .boxStyle2085 {
    font-family: TamediaChart, sans-serif;
    font-family: var(--font-sans-serif);
    color: #fde4ec;
    background: #ec1561;
    padding: 0.1em 0.3em;
    text-decoration: none;
    font-weight: 700;
    @media screen and (max-width: 599px) {
      font-size: 0.9em;
    }
  }

  .boxStyle2085.rain {
    color: #f5f2e8;
    background: #9b8557;
  }

  .boxStyle2060 {
    font-family: TamediaChart, sans-serif;
    font-family: var(--font-sans-serif);
    color: #fbe9e7;
    background: #ff5607;
    padding: 0.1em 0.3em;
    text-decoration: none;
    font-weight: 700;
    @media screen and (max-width: 599px) {
      font-size: 0.9em;
    }
  }

  .boxStyle2060.rain {
    color: #dff2f1;
    background: #009788;
  }

  .boxStyleToday {
    font-family: TamediaChart, sans-serif;
    font-family: var(--font-sans-serif);
    color: #fff3df;
    background: #f90;
    padding: 0.1em 0.3em;
    text-decoration: none;
    font-weight: 700;
    @media screen and (max-width: 599px) {
      font-size: 0.9em;
    }
  }

  .boxStyle2060,
  .boxStyle2085,
  .boxStyleToday,
  .boxStyle2060.rain,
  .boxStyle2085.rain {
    color: #fff;
  }

  .boxStyle2 {
    border-bottom: 2px solid #ff5607;
    // font-weight: 700;
  }
`
export default MainComponent
